import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = ({ auth, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.loaded && auth.token && auth.user.profile.isAdmin ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
);
